import { render } from "./ListiniDetail.vue?vue&type=template&id=41dc94c6"
import script from "./ListiniDetail.vue?vue&type=script&lang=js"
export * from "./ListiniDetail.vue?vue&type=script&lang=js"

import "./ListiniDetail.vue?vue&type=style&index=0&id=41dc94c6&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__